export default __webpack_public_path__ + "static/media/269.8c436f72.png";